import './stimulus'
import './star-rating.min'
import './modal.js'
import './flash.js'
import { getUrlParams } from 'shared/js/common';
import $ from "jquery";
global.$ = jQuery;

document.addEventListener('DOMContentLoaded', () => {
  $('[data-toggle="tooltip"]').tooltip();
})

function delay(callback, ms) {
  var timer = 0;
  return function() {
    var context = this, args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      callback.apply(context, args);
    }, ms || 0);
  };
}

// Search products
$(document).on("click", ".search-product-companies", function(e) {
  filter($("#search-products").val().toLowerCase())
})

$(document).on("click", ".new-search-product-companies", function(){
  $("#loading_complete")[0].attributes["loading-process"].value = true;
  $(".products-list-container .product-detail-small").remove();
  $(".waiting_filter_small_detail_product").removeClass("hidden");
})

$(document).on("click", "#clear-filter", function(e) {
  $(".rounded-lg").removeClass("hidden");
  $("#search-products").val("");
})

$(document).click(function(e) {
  let container = $(".public-navbar-menu");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    container.removeClass("show");
  }
});

$(document).on("click", ".close-widget-reviews", function(e) {
  window.parent.postMessage("close-iframe", '*');
});

$(document).on("click", ".load-more-review-widget", function(e) {
  window.parent.postMessage("ajax-request", '*');
});

$(document).on("click", ".expandbtn-description, .expandbtn-about-company", function() {
  if($(this).closest('.truncate-text').find('.truncate-section').hasClass("read-more")) {
    $(this).html('Show more');
    $(this).closest('.truncate-text').find('.truncate-section').removeClass("read-more");
    $(this).closest('.truncate-text').find('.truncate-section').addClass('line-clamp-10');
  } else {
    $(this).html('Show less');
    $(this).closest('.truncate-text').find('.truncate-section').addClass("read-more");
    $(this).closest('.truncate-text').find('.truncate-section').css("max-height", "none");
    $(this).closest('.truncate-text').find('.truncate-section').removeClass('line-clamp-10');
  }
});

$(document).on("click", ".redirect-gpi", function(e) {
  let value = $(this).next().val();
  window.open(value, '_blank');
});

$(document).ready(function() {
  const element = document.querySelectorAll('.truncate-section');

  for (var i = 0; i < element.length; i++) {
    if (element[i].offsetHeight < element[i].scrollHeight ||
        element[i].offsetWidth < element[i].scrollWidth) {
          element[i].closest('.truncate-text').querySelector('.expandbtn').style.visibility = "visible";
    } else {
      element[i].closest('.truncate-text').querySelector('.expandbtn').style.visibility = "hidden";
    }

    if (element[i].closest('.truncate-text').querySelector('.expandbtn').style.visibility == "hidden") {
      element[i].classList.remove('line-clamp-10');
      element[i].closest('.truncate-text').querySelector('.expandbtn').parentElement.style.display = "none";
    }  
  }

  const elem = $(".loadmore_observer")[0]
  if (elem) {
    let options = {
      rootMargin: "120px",
      threshold: 1.0
    }
  
    function loadMoreProduct(entries){
      let statusLoading = $("#loading_complete")
      if(statusLoading[0] != undefined){
        if(statusLoading[0].attributes["execute"].value == 'false'){
          statusLoading[0].attributes["execute"].value = true;
        }else if(statusLoading[0].attributes["loading-process"].value == 'false' && statusLoading[0].attributes["loading-complete"].value == 'false'){
          statusLoading[0].attributes["loading-process"].value = true;
          $("#btn-loadmore-small-detail-product")[0].click();
        }
      }
    }

    const observer = new IntersectionObserver(loadMoreProduct, options)
    observer.observe(elem)
  }
});

$(document).on("click", "#btn-loadmore-small-detail-product", function(e) {
  let url = this.attributes["data-url"].value
  let method = this.attributes["data-method"].value
  $.ajax({
    url: `${url}`,
    method: `${method}`,
    dataType: 'script',
    beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))}
  });
})


function filter(keyword){

  $(".rounded-lg").removeClass("hidden");

  if (keyword != "") {
    $(".rounded-lg").each(function (i) {
      let account_name = $(this).data("prd-name").toLowerCase();
      if (!account_name.includes(keyword)) {
        $(this).addClass("hidden");
      }
    })
  }
}

$(document).on("keypress", "#search-products", function(e) {
  if(e.which == 13) {
    filter($(this).val().toLowerCase())
  }
})

$(document).ready(function(){
  $(".interactive-text").hover(function(){
    $(this).find(".tip-interactive").removeClass("opacity-0")
  })

  $(".interactive-text").mouseleave(function(){
    $(this).find(".tip-interactive").addClass("opacity-0")
  })

  const toggleContentVisibility = (contents, maxVisibleItems, button) => {
    if (contents.length > maxVisibleItems) {
      button.removeClass('hidden');
      contents.slice(maxVisibleItems).addClass('hidden');
    }

    button.on('click', function () {
      const isExpanded = $(this).text() === 'See less';
      $(this).text(isExpanded ? 'See more' : 'See less');
      contents.toggleClass('hidden', isExpanded);
      contents.slice(0, maxVisibleItems).removeClass('hidden');
    });
  };
  toggleContentVisibility($('.booking_faqs'), 5, $('#expand-faqs'));
  toggleContentVisibility($('.contact-section'), 5, $('#expand-contact-public'));
  toggleContentVisibility($('.sst-review-content'), 2, $('#expand-reviews-sst'));
  toggleContentVisibility($('.booking_faqs_div'), 5, $('#expand-faqs-sst'));
})

//Search location
$(function () {
  $('#search_location').on('keyup', function () {
    let locationIds = [];
    var query = String(this.value).toLowerCase();
    let countLocation = 0;
    let countCity = 0;
    $('.search-location').each(function (i) {
      let value = String($(this).data("pr-name")).toLowerCase();
      if (value.includes(query)) {
        $(this).removeClass('hidden');
        $(this).show();
        countLocation ++;
        let locationId = $(this).find('input').val().slice(1,-1).replace(/"|,/g, '').split(" ");
        locationIds = locationIds.concat(locationId);
      } else {
        $(this).hide();
      }
      if (countLocation > 5){
        $(this).hide();
      }
      if ($(this)[0].children[1].checked){
        $(this).removeClass('hidden');
        $(this).show();
      }
    });
    $('.search-city').each(function(i) {
      let city = $(this).find('input').val().slice(1,-1).replace(/"|,/g, '').split(" ");
      for (let i = 0; i < locationIds.length; i++){
        if (city.includes(locationIds[i])) {
          $(this).removeClass('hidden').addClass('filter-country');
          $(this).show();
          countCity ++;
          break;
        } else {
          $(this).removeClass('filter-country').addClass('hidden');
        }
      }
      if (countCity > 5){
        $(this).addClass('hidden');
      }
      if ($(this)[0].children[1].checked){
        $(this).removeClass('hidden');
        $(this).show();
      }
    });
    if (query === ""){
      $('.search-location, .search-city').each(function(i) {
        if ($(this)[0].children[1].checked){
          $(this).removeClass('hidden');
          $(this).show();
        }else{
          $(this).addClass('hidden');
        }
      })
    }
  });

  // clear filter
  $('.clear-filter-country').on('click', function () {
    $('.search-location input:checkbox:checked').click();
    $('.search-city input:checkbox:checked').click();
  })
  $('.clear-filter-city').on('click', function () {
    $('.search-city input:checkbox:checked').click();
  })
});

//search category
$(function() {
  $('#search_category').on('keyup', function() {
    var query = String(this.value).toLowerCase();
    let count = 0;
    $('.search-category').each(function(i) {
      $('#categories_all').hide()
      let value = String($(this).data("ct-name")).toLowerCase()
        if (value.includes(query)) {
            $(this).removeClass('hidden');
            $(this).show();
            count ++;
        }else{
            $(this).hide();
        }
        if (count > 5){
          $(this).hide();
        }
      });
      if (query === ""){
        $('#categories_all').show();
      }
  });  
});
// search API Providers
$(function() {
  $('#search_api').on('keyup', function() {
    var query = String(this.value).toLowerCase();
    let count = 0;
    $('.search-api').each(function(i) {
      $('#api_providers_all').hide()
      let value = String($(this).data("api-name")).toLowerCase()
        if (value.includes(query)) {
            $(this).removeClass('hidden');
            $(this).show();
            count ++;
        }else{
            $(this).hide();
        }
        if (count > 5){
          $(this).hide();
        }
    });
    if (query === ""){
      $('#api_providers_all').show();
    }
  });  
});

// Search operation
$(document).on('keyup', '#search_operation', function() {
  const query = String(this.value).toLowerCase();
  const url = $(this).attr("data-url");
  const obj = $(this);
  $.ajax({
    url: `/${url}`,
    type: 'get',
    data: { query: query },
    dataType: 'text',
    success: function (data) {
      obj.parents('.flex-col').find('.dropdown-search').html(data);
    }
  });
});

$(document).on('keyup', '#search_location, #search_city', function() {
  const country = $('#search_location').val(),
    city = $('#search_city').val(),
    url = $(this).attr("data-url"),
    model = $(this).attr("data-model"),
    obj = $(this),
    citiesInUrl = getUrlParams('city'),
    countriesInUrl = getUrlParams('country');
  $.ajax({
    url: `/${url}`,
    type: 'get',
    data: { country: country, city: city, model: model, citiesInUrl: citiesInUrl, countriesInUrl: countriesInUrl },
    dataType: 'text',
    success: function (data) {
      obj.parents('.flex-col').find('.dropdown-search').html(data);
    }
  });
});

// view all location
$(function() {
  $('#location_all').on('click', function() {
    $('#location_all').hide()
    $('.search-location').removeClass('hidden');
    $('#location_default').removeClass('hidden')
  });  
});

$(function() {
  $('#location_default').on('click', function() {
    let location_length = $('.search-location').length;
    $('#location_all').removeClass('hidden');
    $('#location_all').show();
    $('#location_default').hide();
    $('.search-location').slice(5 , location_length + 1).each(function(i){
      $(this).addClass('hidden');
    });
  });  
});

// view all product page
$(function() {
  $('.view-all').on('click', function() {
    $(this).hide();
    $(this).parents('.filter-product').find('.search-ele').removeClass('hidden').show();
    $(this).parents('.filter-company').find('.search-ele').removeClass('hidden').show();
  });
});

//show modal of health items
$(function() {
  $('.health-btn').on('click', function() {
    $('#showHealthModal').show();
  });  
});

//close health modal
$(function() {
  $('.btn-health-close').on('click', function() {
    $('#showHealthModal').addClass('hidden');
  });  
});

//open login modal
$(function() {
  $('.show-login-modal').on('click', function() {
    $('#create_modal').modal('show');
  });  
});

//copied url to clipboard
$(function() {
  $('.btn-copy-link').on('click', function() {
    const $temp = $("<input>");
    const $url = $(location).attr('href');
    $("body").append($temp);
    $temp.val($url).select();
    document.execCommand("copy");
    $temp.remove();
    showError('Url Copied');
  });
});

$(function() {
  const percent_complete_score = $('.percent_complete_score').text();
  const el = '#specificChart';
  const perc = parseInt(percent_complete_score);
  const percent = Math.round(perc);
    if (percent > 100) {
        percent = 100;
    } else if (percent < 0) {
        percent = 0;
    }
    var deg = Math.round(360 * (percent / 100));

    if (percent > 50) {
        $(el + ' .pie').css('clip', 'rect(auto, auto, auto, auto)');
        $(el + ' .right-side').css('transform', 'rotate(180deg)');
    } else {
        $(el + ' .pie').css('clip', 'rect(0, 1em, 1em, 0.5em)');
        $(el + ' .right-side').css('transform', 'rotate(0deg)');
    }
    if (true) {
        $(el + ' .right-side').css('border-width', '0.1em');
        $(el + ' .left-side').css('border-width', '0.1em');
        $(el + ' .shadow').css('border-width', '0.1em');
    } else {
        $(el + ' .right-side').css('border-width', '0.5em');
        $(el + ' .left-side').css('border-width', '0.5em');
        $(el + ' .shadow').css('border-width', '0.5em');
    }
    $(el + ' .num').text(percent);
    $(el + ' .left-side').css('transform', 'rotate(' + deg + 'deg)');
});

var recorder, gumStream;
var recordButton = document.getElementById("recordButton");
$(document).on("click", "#recordButton", function(){
  let inputPrompt = $("#chat-side"); 
  let productId  = inputPrompt[0].attributes["data_product_id"].value;
  if (recorder && recorder.state == "recording") {
    recorder.stop();
    gumStream.getAudioTracks()[0].stop();
    $(".recoding-voice").remove();
    $(".input-message")[0].innerHTML = `<div class="type-area w-full typing-text">
      <div class="input-wrapper pt-2 w-4/5">
        <textarea class="frompt-traslate-optimize-text-to-speech text_input w-full" data_account_id="7af115c9-29e3-4af5-90b4-3cde17b91bdd" name="result_text_convert" placeholder="Start..." type="text" style="overflow: hidden; overflow-wrap: break-word; resize: none; height: 36px;"></textarea>
      </div>
      <span class="button-add ml-4 py-2">
        <a id="recordButton" href="javascript:void(0)">
          <i class="fa fa-microphone"></i>
        </a>
      </span>
      <button class="flex btn-chat button-send py-2 pb-3 start-convert-text-to-speech">
        <i class="fa fa-paper-plane"></i>
      </button>
    </div>`
    $(".overflow-auto.chat-content-flow").stop().animate({ scrollTop: $(".overflow-auto.chat-content-flow")[0].scrollHeight}, 0);
  } else {
    let srcImageChatBot = $(".icon-avatar-chat-bot")[0].attributes["src"].value;
    $(".typing-text").remove();
    $(".input-message")[0].innerHTML = `<div class="type-area w-full recoding-voice">
      <div id="recording-waiting">
        <div id="bars-recording">
          <div class="bar-recording"></div>
          <div class="bar-recording"></div>
          <div class="bar-recording"></div>
          <div class="bar-recording"></div>
          <div class="bar-recording"></div>
          <div class="bar-recording"></div>
          <div class="bar-recording"></div>
          <div class="bar-recording"></div>
          <div class="bar-recording"></div>
          <div class="bar-recording"></div>
        </div>
      </div>
      <span class="button-add ml-4 py-2">
        <a id="recordButton" href="javascript:void(0)">
          <i class="fa fa-paper-plane"></i>
        </a>
      </span>
    </div>`

    navigator.mediaDevices.getUserMedia({
      audio: true
    }).then(function(stream) {
      gumStream = stream;
      recorder = new MediaRecorder(stream);
      recorder.ondataavailable = function(e) {
        var url = URL.createObjectURL(e.data);
        var preview = document.createElement('audio');
        preview.controls = true;
        preview.src = url;
        $("#audio").append(preview);
        let data = new FormData();
        data.append('file', e.data);
        data.append('product_id', productId);
        $(".chat-content-flow").append(`
          <div class="message message-right thinking-message">
            <div class="avatar-wrapper avatar-small">
              <img src="${srcImageChatBot}">
            </div>
            <div class="bubble bubble-light message-text">
              <div class="flex justify-center wait-typing-box p-2">
                <div class="wait-typing flex">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
          </div>
        `)
        $.ajax({
          url: `/optimize_speech_to_text`,
          method: 'POST',
          datatype: "json",
          data: data,
          processData: false,
          contentType: false,
          beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
          success: function(data) {
            $(".thinking-message").remove();
            let inputPrompt = $(".frompt-traslate-optimize-text-to-speech");
            inputPrompt[0].value = data.text_content;
            $(".start-convert-text-to-speech").click();
          }
        })
      };
      recorder.start();
    });
  }
})

$(document).on("click", ".start-convert-text-to-speech", function(){
  let chatSide          = $("#chat-side");
  let srcImageChatBot   = $(".icon-avatar-chat-bot")[0].attributes["src"].value;
  let srcImageIconUser  = $(".icon-avatar-icons-user")[0].attributes["src"].value;
  let inputPrompt       = $(".frompt-traslate-optimize-text-to-speech");
  let textPrompt        = inputPrompt[0].value;
  let productID         = chatSide[0].attributes["data_product_id"].value;
  inputPrompt[0].value = "";
  $(".chat-content-flow").append(`
    <div class="message message-right">
      <div class="avatar-wrapper avatar-small">
        <img src="${srcImageIconUser}">
      </div>
      <div class="bubble bubble-dark message-text">
        ${textPrompt.trim().replaceAll("\n", "<br/>")}
      </div>
    </div>`
  )

  $(".chat-content-flow").append(`
    <div class="message message-left thinking-message">
      <div class="avatar-wrapper avatar-small">
        <img src="${srcImageChatBot}">
      </div>
      <div class="bubble bubble-light message-text">
        <div class="flex justify-center wait-typing-box p-2">
          <div class="wait-typing flex">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  `)

  $(".result-chat-voice").addClass("hidden");
  $(".wait-typing-box").removeClass("hidden");
  $(".overflow-auto.chat-content-flow").stop().animate({ scrollTop: $(".overflow-auto.chat-content-flow")[0].scrollHeight}, 0);
  $.ajax({
    url: `/send_request_assistant`,
    type: 'post',
    data: {type_prompt: "request_assistant", question: textPrompt, product_id: productID},
    beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
    success: function (data) {
      speakResultGpt(data.result_original, data.result, srcImageChatBot, textPrompt)
    },
    error: function () {
      showError("Error occurred!")
    }
  });
})

function speakResultGpt(text, text_html, image_url, question){
  $.ajax({
    url: `/convert_text_to_speech`,
    type: 'post',
    data: {text: text, question: question},
    beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
    success: function (data) {
      var snd = new Audio("data:audio/x-wav;base64," + data.result);
      snd.onended = function() {
        $(".fa-volume-up").removeClass("active");
      };
      $("#audio-result-voice").empty().append(snd);
      snd.play();
      $("#turn-on-voice").addClass("hidden");
      $("#mute-voice").removeClass("hidden");
      $(".fa-volume-up").addClass("active");
      $(".thinking-message").remove();
      $(".chat-content-flow").append(`
        <div class="message message-left">
          <div class="avatar-wrapper avatar-small">
            <img src="${image_url}">
          </div>
          <div class="bubble bubble-light message-text">
            ${text_html.trim()}
          </div>
        </div>`
      )
      $(".overflow-auto.chat-content-flow").stop().animate({ scrollTop: $(".overflow-auto.chat-content-flow")[0].scrollHeight}, 0);
      $(".result-chat-voice").removeClass("hidden");
      $(".wait-typing-box").addClass("hidden");
    },
    error: function () {
      showError("Error occurred!")
    }
  });
}

$(document).on("click", ".close-box-chat", function(){
  $("#chat-side").addClass("hidden");
  $("#mini-chat").removeClass("hidden")
})

$(document).on("click", "#mini-chat", function(){
  $("#chat-side").removeClass("hidden");
  $("#mini-chat").addClass("hidden")
})

$(document).on("click", ".close-windown-box-chat", function() {
  $("#mini-chat").remove();
  $("#chat-side").remove();
})

$(document).on("keypress", ".frompt-traslate-optimize-text-to-speech", function(event){
  if (event.keyCode == 13) {       
    if(event.shiftKey){
      this.value = content.substring(0, caret - 1) + "\n" + content.substring(caret, content.length);
      event.stopPropagation();
    } else {
      event.preventDefault();
      $(".start-convert-text-to-speech").click();
    }
  }
})


$(document).on("click", "#mute-voice", function(){
  let sound = $("#audio-result-voice").find("audio");
  if($(this).find(".fa-volume-up")[0].classList.contains("active")){
    $("#turn-on-voice").removeClass("hidden");
    $(this).addClass("hidden");
    if(sound.length > 0){
      sound[0].pause();
      sound[0].currentTime = 0;
    }
  }else{
    $(".fa-volume-up").addClass("active");
    if(sound.length > 0){
      sound[0].play();
      sound[0].onended = function() {
        $(".fa-volume-up").removeClass("active");
      };
    }
  }
})

$(document).on("click", "#turn-on-voice", function(){
  $("#mute-voice").removeClass("hidden");
  $(this).addClass("hidden");
  let sound = $("#audio-result-voice").find("audio");
  if(sound.length > 0){
    sound[0].onended = function() {
      $(".fa-volume-up").removeClass("active");
    };
    sound[0].play();
  }
})

$(document).on("click", ".white-lable-open-mini-chat", function(){
  $("#mini-chat").removeClass("hidden");
})

$(document).on("click", ".load-player-intro", function(){
  let productID = $(".audio-intro-play")[0].attributes["data-product-id"].value;
  $(".waiting-load-intro").removeClass("hidden");
  $(".load-player-intro").addClass("hidden");
  $.ajax({
    url: `/send_request_assistant`,
    type: 'post',
    data: {type_prompt: "product_introduction",product_id: productID},
    beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
    success: function (data) {
      addAudioIntroduction(data.result);
    },
    error: function () {
      showError("Error occurred!")
    }
  });
})

$(document).on("click", ".switch-tab-review-widget", function(){
  let target = $(this).data("target");
  let tablist = $(this).closest('[role="tablist"]');
  tablist.find('.tab-pane.active').removeClass('active');
  $(`${target}-2`).addClass("active");
})

function addAudioIntroduction(text){
  $.ajax({
    url: `/convert_text_to_speech`,
    type: 'post',
    data: {text: text},
    beforeSend: function(xhr) {xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))},
    success: function (data) {
      $(".load-player-intro").addClass("hidden");
      $(".waiting-load-intro").addClass("hidden");
      $(".audio-introduce-player").removeClass("hidden");
      var snd = new Audio("data:audio/x-wav;base64," + data.result);
      snd.controls = true;
      $(".radio-intro-controls").empty().append(snd);
      snd.play();
    },
    error: function () {
      showError("Error occurred!")
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll("a[href$='product'], a[href$='about']").forEach(function(tab) {
    tab.onclick = function(e) {
      var href = e.target.getAttribute('href');
      if(href.endsWith('product')) {
        $('#search-form').removeClass('hidden');
      } else if(href.endsWith('about')) {
        $('#search-form').addClass('hidden');
      }
    };
  });
});

$(document).on("click", "#show-more-products-public", function(){
  document.querySelector('a[href="#product"]').click();
});

$(document).on('click', '.show-more-btn', function() {
  const container = $(this).closest('.description-container');
  const truncated = container.find('.truncated-text');
  const full = container.find('.full-text');
  
  truncated.toggleClass('hidden');
  full.toggleClass('hidden');
  
  $(this).text(truncated.hasClass('hidden') ? 'Show less' : 'Show more');
});

$(document).on('click', '.more-options', function() {
  const $button = $(this);
  const $hiddenOptions = $button.closest('div').find('.hidden-options');
  const $hiddenPrices = $button.closest('.row').find('.hidden-prices');
  const $icon = $button.find('i');
  const optionsCount = $hiddenOptions.find('a').length;
  
  $hiddenOptions.toggleClass('hidden');
  $hiddenPrices.toggleClass('hidden');
  $icon.toggleClass('rotate-180');
  
  if ($hiddenOptions.hasClass('hidden')) {
    $button.html(`${optionsCount} more options <i class="fas fa-chevron-down transition-transform duration-200"></i>`);
  } else {
    $button.html(`Show less <i class="fas fa-chevron-down rotate-180 transition-transform duration-200"></i>`);
  }
});

$(document).on('click', '#prevBtn', function(e) {
  e.preventDefault();
  const gallery = document.getElementById('imageGallery');
  if (gallery) {
    gallery.scrollBy({
      left: -800,
      behavior: 'smooth'
    });
  }
});

$(document).on('click', '#nextBtn', function(e) {
  e.preventDefault();
  const gallery = document.getElementById('imageGallery');
  if (gallery) {
    gallery.scrollBy({
      left: 800,
      behavior: 'smooth'
    });
  }
});

$(document).on('click', '.skip-claim-business', function() {
  const domain = $('input[name="account[website]"').val();
  const name = $('input[name="account[email]"').val();
  if (name === '' || domain === '') {
    showError('Name and domain are required to skip');
    return;
  }
  $.ajax({
    url: `/claim_business_bypass_verification?name=${name}&_domain=${domain}`,
    method: 'POST',
    datatype: 'json',
    data: {
      name: $('#claim_business_name').val(),
      website: $('#claim_business_website').val()
    },
    success: function(response) {
      if (response.status == '500') {
        showError('Website domain is already claimed');
      } else {
        window.location = response.url;
      }
    },
  });
});

$(document).on('keyup', '.google_placeID', delay(function() {
  const placeTab = $(this).attr("data-place-tab");
  const currentAddressType = $(this).attr("current-address-type");
  const googlePlace = $(this).val();
  if (googlePlace.length > 0) {
    $.ajax({ 
      url: `/companies/get_places`,
      method: 'GET',
      datatype: 'json',
      data: { google_place: googlePlace,T: placeTab },
      success: function(data) {
        if(data.length != 0){
          $('#google_place_select_box input').hide();
          for (let i = 0; i < 5; i++) {
            $(`.${currentAddressType}`).find(`#google_place_select_box .google-places-item${i}`).show().attr('value', data[i][0]).attr('places_id', data[i][1]).attr('main_address', data[i][2]).attr('secondary_address', data[i][3]);
          };
        } else {
          $('#google_place_select_box input').hide();
        }
      },
      error: function () {
        showError("Point of interest does not exist!")
      },
    });
  } else {
    $('#google_place_select_box input').hide();
  }
}, 500));

$(document).on('mouseup', '.google-places-select', function (e) {
  const currentAddressType = $(this).closest('#google_place_select_box').attr('current-address-type');
  $(`.${currentAddressType}`).find('.google_placeID').val($(this).find('input').attr('value'))
  $(`.${currentAddressType}`).find('.google_placeID').attr('places_id',$(this).find('input').attr('places_id')).attr('main_address_name', $(this).find('input').attr('main_address'))
  $('#google_place_select_box input').hide();
});

$(document).on('click', function(event) {
  if (!$(event.target).closest('#google_place_select_box').length && 
      !$(event.target).closest('.google_placeID').length) {
    $('#google_place_select_box input').hide();
  }
});

function requestGenerateCollector(data) {
  const url = `/companies/generate_collector_from_source`;
  const accountId = $("#data-account-id").val();
  return new Promise((resolve, reject) => {
    $.ajax({
      url: url,
      method: 'POST',
      datatype: 'json',
      data: data,
      success: function(response) {
        if (Object.keys(response.collectors).length > 0) {
          const promises = Object.keys(response.collectors).map(key => {
            let value = response.collectors[key];
            return new Promise((res, rej) => {
              $.ajax({
                url: '/companies/create_collector_summary',
                method: 'POST',
                datatype: 'json',
                data: { _account: accountId, source: key, value: value },
                success: function(summaryResponse) {
                  if (typeof summaryResponse === 'undefined') {
                    showError('Something source can not get data, please check it');
                    return res();
                  }
                  res(summaryResponse);
                },
                error: function(error) {
                  rej(error);
                }
              });
            });
          });
          Promise.all(promises)
            .then(results => {
              $.ajax({
                url: '/companies/update_fields_from_collector',
                method: 'PUT',
                datatype: 'json',
                data: {
                  results: results,
                  _account: accountId
                },
                success: function(response) {
                  $.ajax({
                    url: '/companies/generate_full_profile_with_prompt',
                    method: 'POST',
                    datatype: 'json',
                    data: {
                      _account: accountId
                    },
                    success: function(response) {
                      if (response.status != 'undefined' && response.status == 'success') {
                        $("#request-full-profile")[0].attributes["data-status-id"].value = response.data_id;
                        $("#request-full-profile").trigger("click");
                      }
                    }
                  });
                }
              });
            })
            .catch(error => {
              reject(error);
            });
        } else {
          resolve();
        }
      },
      error: function(error) {
        reject(error);
      }
    });
  });
}

$(document).on("click", ".generate-sst-collector", function() {
  $('#highlighted-json-collector, #generate-sst-profile, #result-pois, #result-positions').addClass('hidden');
  const accountId = $("#data-account-id").val();
  const collectors = [
    { field: '#collector-google', key: 'collector_google' },
    { field: '#collector-tripadvisor', key: 'collector_tripavisor' },
    { field: '#collector-website', key: 'collector_website' },
    { field: '#collector-ota', key: 'collector_ota' }
  ];
  const requests = collectors.map(({ field, key }) => {
    if ($(field).val()) {
      document.querySelectorAll('.generate-sst-collector').forEach(otherButton => {
        if (otherButton !== this) {
          otherButton.classList.add('hidden');
        }
      });
      $(this).addClass('btn-loading');
      let data = { _account: accountId };
      data[key] = $(field).val();
      return requestGenerateCollector(data);
    }
    return null;
  }).filter(promise => promise !== null);
  Promise.all(requests)
    .then((results) => {
    })
    .catch((error) => {
      showError('It seems that there is an error with the source. Please check again.');
      $('.generate-sst-collector').removeClass('btn-loading hidden');
    });
});

$(document).on("click", "#request-full-profile", function() {
  let statusID = $(this)[0].attributes["data-status-id"].value;
  const accountId = $("#data-account-id").val();
  const url = `/companies/generate_full_profile_with_prompt?_account=${accountId}`;
  setTimeout(function() {
    $.ajax({
      url: url,
      method: 'GET',
      datatype: 'json',
      data: {
        id_status_gpt: statusID
      },
      success: function(response) {
        if (response.status != 'undefined' && response.status == 'success') {
          $.ajax({
            url: `/companies/create_profile_and_faqs?_account=${accountId}`,
            method: 'POST',
            error: function(error) {
              showError('Something went wrong.');
              $('.generate-sst-collector').removeClass('btn-loading hidden');
            },
            success: function(response) {
              if (response.status != 'undefined' && response.status == 'success') {
                $("#request-generate-faqs")[0].attributes["data-status-id"].value = response.data_id;
                $("#request-generate-faqs").trigger("click");
              }
            }
          });
        }else{
          $("#request-full-profile")[0].attributes["data-status-id"].value = response.data_id;
          $("#request-full-profile").trigger("click");
        }
      },
      error: function(error) {
        showError('Something went wrong.');
        $('.generate-sst-collector').removeClass('btn-loading hidden');
      }
    });
  }, 5000);
});

$(document).on("click", "#request-generate-faqs", function() {
  let statusID = $(this)[0].attributes["data-status-id"].value;
  $('#generate-sst-profile').addClass('btn-loading');
  const accountId = $("#data-account-id").val();
  const url = `/companies/create_profile_and_faqs?_account=${accountId}`;
  setTimeout(function() {
    $.ajax({
      url: url,
      method: 'GET',
      datatype: 'json',
      data: {
        id_status_gpt: statusID
      },
      success: function(response){
        if (response.status != 'undefined' && response.status == 'proccessing') {
          $("#request-generate-faqs")[0].attributes["data-status-id"].value = response.data_id;
          $("#request-generate-faqs").trigger("click");
        }else{
          window.location.href = `/companies/show_profile_and_faqs?_account=${accountId}&_data=${response.data_id}`;
        }
      },
      error: function(error) {
        showError('Something went wrong.');
        $('.generate-sst-collector').removeClass('btn-loading hidden');
      }
    });
  }, 5000);
});

$(document).on('click', '#collector-product', function() {
  const accountId = new URLSearchParams(window.location.search).get('_account');
  let url = `/companies/get_list_products_collector?_account=${accountId}`;
  let supplier_id = $('#supplier_id').val();
  if (!supplier_id.length) return showError('Data for supplier not available');
  $(this).addClass('btn-loading');
  $.ajax({
    url: url,
    method: 'POST',
    datatype: 'json',
    data: {
      supplier_id: supplier_id
    },
    success: function(response) {
      $.ajax({
        url: `/companies/get_list_products_collector?_account=${accountId}&status_id=${response.status_id}&check=true`,
        method: 'GET',
        dataType: 'json',
        success: function(response) {
          $("#check-status-collector")[0].attributes["data-status-id"].value = response.data_id;
          $('#check-status-collector').trigger('click');
        }
      });
    },
    error: function(error) {
      $('#product-search-loading').addClass('hidden');
      $('#profile_tab_collector').removeClass('hidden');
      showError('Something went wrong.');
    }
  });
});

$(document).on('click', '#check-status-collector', function(e) {
  let checkStatusId = this.getAttribute('data-status-id');
  const accountId = new URLSearchParams(window.location.search).get('_account');
  setTimeout(function() {
    $.ajax({
      url: `/companies/get_list_products_collector?_account=${accountId}&status_id=${checkStatusId}&check=true`,
      method: 'GET',
      dataType: 'json',
      success: function(response) {
        if (response.status != 'undefined' && response.status == 'success') {
          window.location.href = response.url
        }else{
          $("#check-status-collector")[0].attributes["data-status-id"].value = response.data_id;
          $('#check-status-collector').trigger('click');
        }
      },
      error: function(error) {
        showError('Failed to check collector status');
      }
    });
  }, 3000);
});

$(document).on('click', '#submit-create-listing', function() {
  $(this).addClass('btn-loading');
  const accountId = new URLSearchParams(window.location.search).get('_account');
  $.ajax({
    url: `/companies/create_collector_products?_account=${accountId}`,
    method: 'POST',
    datatype: 'json',
    success: function(response) {
      if (response.success) {
        window.location.href = response.url
      }
    },
    error: function(error) {
      $('#submit-create-listing').removeClass('btn-loading');
      showError('Something went wrong. Please try again');
    }
  });
});
